import axios from "../../../config/axiosConfig";

export const obtenerDolarActual = () =>
  axios.get("/api/dolar");

export const obtenerHistorialDolar = ({ page = 1, limit = 20 } = {}) =>
  axios.get("/api/dolar/historial", { params: { page, limit } });

export const actualizarDolar = (cod, body) =>
  axios.put(`/api/dolar/${cod}`, body);
